import React from 'react';
import * as PropTypes from 'prop-types';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

// the Node SSR server has no <html lang> to detect the language from, and it renders every site,
// so it gets the page language explicitly and uses its own i18n copy instead of the shared one
const ServerLanguage = ({ language = null, children }) => {
  if (typeof window !== 'undefined' || !language) {
    return children;
  }

  return (
    <I18nextProvider i18n={i18n.cloneInstance({ lng: language })}>
      {children}
    </I18nextProvider>
  );
};

export default ServerLanguage;

ServerLanguage.propTypes = {
  language: PropTypes.string,
  children: PropTypes.node.isRequired
};
